import { render, staticRenderFns } from "./TarifItem.vue?vue&type=template&id=0e956150&scoped=true"
import script from "./TarifItem.vue?vue&type=script&lang=js"
export * from "./TarifItem.vue?vue&type=script&lang=js"
import style0 from "./TarifItem.vue?vue&type=style&index=0&id=0e956150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e956150",
  null
  
)

export default component.exports